/**
 * Wishlist functionality for managing user's wishlist items
 * Uses localStorage to persist wishlist data
 */

(function() {
  'use strict';

  var $wishlistButton = $('.wishlist-btn');
  var $wishlistTile = $('.wishlist-tile-container');
  var numProductTiles = $wishlistTile.length;
  var wishlist = localStorage.getItem('user_wishlist') || [];
  
  if (wishlist.length > 0) {
    wishlist = JSON.parse(localStorage.getItem('user_wishlist'));
  }

  /**
   * Update button to show current state and display notification
   */   
  var animateWishlist = function (self) {
    var isRemove = $(self).hasClass('is-active');
    if(isRemove){
      $('<div id="alert-success" class="alert alert-danger">Removed from Wishlist</div>').insertBefore('#page').delay(1500).fadeOut(function() {$(this).remove(); });
    }
    else{
      $('<div id="alert-success" class="alert alert-success">Added to Wishlist</div>').insertBefore('#page').delay(1500).fadeOut(function() {$(this).remove(); });
    }
    $(self).toggleClass('is-active');
  };

  /**
   * Initialize wishlist counter in header
   */
  var getfirstvalue = function (self){
    var x = wishlist.length;   
    if($('#totle-product-wishlist').length == 0){
      $('.whishlist-head.popup-over a').append('<span id="totle-product-wishlist">'+x+'</span>');
    }
  };

  /**
   * Add/Remove selected item to the user's wishlist array in localStorage
   * Wishlist button class 'is-active' determines whether or not to add or remove
   */   
  var updateWishlist = function (self) {
    var productHandle = $(self).attr('data-product-handle');
    var isRemove = $(self).hasClass('is-active');
    
    /* Remove */
    if (isRemove) {
      var removeIndex = wishlist.indexOf(productHandle);
      if($('.wishlist-container').hasClass('page-wishlist')){
        wishlist.splice(removeIndex, 1);
        localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
        $(self).closest('.product-tile-container').remove();
        if($('.product-tile-container').length == 0 ){
          location.reload();
        }
      }
      else{
        wishlist.splice(removeIndex, 1);
        localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
        $(self).find('.txt_w').text('Add to Wishlist');
        $(self).attr("title", "Add to Wishlist");
      }
    }
    /* Add */ 
    else {
      wishlist.push(productHandle);
      localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
      $(self).find('.txt_w').text('Remove from Wishlist');
      $(self).attr("title", "Remove from Wishlist");
    }
    
    console.log(JSON.stringify(wishlist));
    var x = wishlist.length;  
    $('#totle-product-wishlist').text(x);
  };

  /**
   * Loop through wishlist buttons and activate any items that are already in user's wishlist
   * Activate by adding class 'is-active'
   * Run on initialization
   */   
  var activateItemsInWishlist = function () {
    $wishlistButton.each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(productHandle) > -1) {
        $(this).addClass('is-active');
        $(this).find('.txt_w').text('Remove from Wishlist');
        $(this).attr("title", "Remove from Wishlist");
      }
    });
  };

  /**
   * Loop through product titles and remove any that aren't a part of the wishlist
   * Decrement numProductTiles on removal
   */   
  var displayOnlyWishlistItems = function () {
    $wishlistTile.each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(productHandle) === -1) {
        $(this).remove();
        numProductTiles--;
      }
    });
  };

  /**
   * Check if on the wishlist page and hide any items that aren't a part of the wishlist
   * If no wishlist items exist, show the empty wishlist notice
   */   
  var loadWishlist = function () {
    if (window.location.href.indexOf('pages/wishlist') > -1) {
      displayOnlyWishlistItems();
      $('.wishlist-loader').fadeOut(2000, function () {
        $('.wishlist-grid').addClass('is_visible');
        $('.wishlist-hero').addClass('is_visible');
        if (numProductTiles == 0) {
          $('.wishlist-grid--empty-list').addClass('is_visible');
        } else {
          $('.wishlist-grid--empty-list').hide();
        }
      });
    }
  };

  /**
   * Bind UI actions for wishlist buttons
   */
  var bindUIActions = function () {
    $($wishlistButton).on('click',function (e) {
      e.preventDefault();
      updateWishlist(this);
      animateWishlist(this);
      getfirstvalue();
    });
    
    $('body').on("click",".pop-up-wishlist",function(e){
      e.preventDefault();
      updateWishlist(this);
      animateWishlist(this);
      getfirstvalue();
    });  
  };

  /**
   * Initialize wishlist functionality
   */
  var init = function() {
    // Refresh variables in case DOM has changed
    $wishlistButton = $('.wishlist-btn');
    $wishlistTile = $('.wishlist-tile-container');
    numProductTiles = $wishlistTile.length;
    
    activateItemsInWishlist();
    loadWishlist();
    bindUIActions();
    getfirstvalue();
  };

  // Initialize on DOM ready
  $(document).ready(function() {
    init();
  });

  // Re-initialize after AJAX content loads
  $(document).on('shopify:section:load', function() {
    init();
  });

  // Export for global access if needed
  window.Wishlist = {
    init: init,
    activateItemsInWishlist: activateItemsInWishlist,
    loadWishlist: loadWishlist
  };

})();